<template>
  <div class="medgate-app">
		<base-banner
			:title="banner.title"
			:caption="banner.caption"
			:backgroundImage="banner.image"
			:titleColor="banner.titleColor"
			:captionColor="banner.captionColor"
			:backgroundColor="banner.backgroundColor"
			:buttons="banner.buttons"
		>
			<v-col
				cols="5"
				slot="right-image"
				class="hidden-sm-and-down"
			>
				<v-img
					:style="{ bottom: $vuetify.breakpoint.lgAndUp ? '-150px !important' : '' }"
					contain
					src="@/assets/images/others/doc_juan_2.png"
					:height="$vuetify.breakpoint.md ? '500px' : '630px'"
					data-aos="fade-up"
				></v-img>
			</v-col>
		</base-banner>

		<base-goto color="white"></base-goto>

		<div id="content">
			<div id="video-embed" class="sec">
				<v-container>
					<div class="card-wrap">
						<v-card
							flat
							rounded="lg"
							class="pa-0"
							data-aos="fade-up"
						>
							<v-row justify="center">
								<v-col class="pa-10">
									<iframe
										width="100%"
										:height="iframeHeight"
										src="https://www.youtube.com/embed/tnFXODPZJSk"
										frameborder="0"
										allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
										allowfullscreen
										data-aos="fade-up"
									></iframe>
								</v-col>
							</v-row>
						</v-card>
					</div>
				</v-container>
			</div>

			<div id="video" class="sec">
				<v-container>
					<div class="card-wrap">
						<v-card
							flat
							rounded="lg"
							class="pa-0"
							data-aos="fade-up"
						>
							<v-row>
								<v-col cols="12" sm="12" md="5" lg="5" xl="5">
									<v-container fill-height>
										<div class="mx-5">
											<div class="primary--text font-weight-bold" :class="MIXIN_SETUP_UI.header">
												Video consultation
											</div>
											<!-- <h1 class="primary--text">Video consultation</h1> -->

											<p class="pt-5" :class="MIXIN_SETUP_UI.subtitle">
												With the Medgate App, you can talk to a doctor by video as well as on the phone. So you can talk privately with your doctor, face to face. In some cases, the video connection gives our doctors an even better idea of your health.
											</p>
										</div>
									</v-container>
								</v-col>
								<v-col cols="12" sm="12" md="7" lg="7" xl="7" class="my-0 py-0">
									<v-img
										src="@/assets/images/video_img01.jpg"
										width="100%"
										height="100%"
										class="video-image"
									></v-img>
								</v-col>
							</v-row>
						</v-card>
					</div>
				</v-container>
			</div>

			<div id="features">
				<v-row justify="center" align="center" class="header">
					<div class="text-center">
						<p
							class="primary--text font-weight-black"
							data-aos="fade-up"
							:class="MIXIN_SETUP_UI.header"
						>
							Features
						</p>
						<p
							class="d-block mt-8 px-4"
							data-aos="fade-up"
						>
							Medgate's App has many helpful and user-friendly functions.
						</p>
					</div>
				</v-row>
				<div :style="{ marginTop: $vuetify.breakpoint.mdAndUp ? '-100vh' : '' }">
					<div style="position:sticky;top:0;margin-bottom:100vh;" class="hidden-sm-and-down">
						<v-img
							contain
							height="100vh"
							width="50vw"
							src="~@/assets/images/others/doc_juan_2.png"
							:style="{ position: 'absolute' }"
						></v-img>
					</div>

					<feature-row
						v-for="(feature, key) in features"
						:key="key"
						:title="feature.title"
						:caption="feature.caption"
						:backgroundColor="key % 2 ? 'white' : 'primary'"
						:titleColor="key % 2 ? 'primary' : 'white'"
						:captionColor="key % 2 ? 'black' : 'white'"
					></feature-row>
				</div>
			</div>

			<div id="benefits" class="sec">
				<v-container :class="MIXIN_SETUP_UI.defaultSidePadding">
					<v-row justify="center" data-aos="fade-up">
						<p
							class="head"
							:class="MIXIN_SETUP_UI.header"
						>
							For people insured with the Telmed model
						</p>
					</v-row>

					<v-row>
						<v-col cols="12" sm="12" md="6" lg="6" xl="6">
							<v-card
								rounded="xl"
								flat
								height="380px"
								data-aos="fade-up"
							>
								<v-container fill-height>
									<div class="px-10">
										<div
											class="primary--text mb-5"
											:class="MIXIN_SETUP_UI.header"
										>
											Benefits
										</div>
										<p
											:class="MIXIN_SETUP_UI.subtitle"
										>
											The App helps you to manage all features of your insurance plan. With the digital treatment plan, you have a practical overview of all your treatments, doctors and the treatment duration. You can easily update your treatment plant with the App - for example, if you're referred to another doctor or the duration of your treatment es extended.
										</p>
									</div>
								</v-container>
							</v-card>
						</v-col>
						<v-col cols="12" sm="12" md="6" lg="6" xl="6">
							<v-card
								rounded="xl"
								flat
								height="380px"
								data-aos="fade-up"
							>
								<v-container fill-height class="px-10">
									<!-- <v-list color="transparent">
										<v-list-item class="white--text" v-for="(val, key) in services" :key="key">
											<v-list-item-action>
												<v-icon x-large color="accent">mdi-check-circle</v-icon>
											</v-list-item-action>

											<v-list-item-content>
												<div v-if="$vuetify.breakpoint.xs" class="primary--text" :class="MIXIN_SETUP_UI.title">{{ val }}</div>
												<div v-else class="primary--text" :class="MIXIN_SETUP_UI.title">{{ val }}</div>
											</v-list-item-content>
										</v-list-item>
									</v-list> -->
									<div class="white--text" v-for="(val, key) in services" :key="key">
										<div>
											<div class="d-flex align-center">
												<v-icon x-large color="accent" class="pr-4">mdi-check-circle</v-icon>
												<div class="primary--text" :class="MIXIN_SETUP_UI.title">{{ val }}</div>
											</div>
										</div>
									</div>
								</v-container>
							</v-card>
						</v-col>
					</v-row>


					<v-card
						color="#1d87fd"
						rounded="xl"
						flat
						:height="$vuetify.breakpoint.mdAndDown ? '' : '500px'"
						data-aos="fade-up"
					>
						<v-row :class="[ $vuetify.breakpoint.xs ? 'pa-5' : '', 'app-row mt-5' ]">
							<v-col cols="5" class="hidden-md-and-down">
								<div class="image"></div>
							</v-col>
							<v-col cols="12" sm="12" md="12" lg="7" xl="7">
								<v-container fill-height>
									<v-row justify="center" align="center">
										<div>
											<div class="font-weight-bold" :class="MIXIN_SETUP_UI.header">Call Doc. Anywhere.</div>
											<div class="font-weight-bold" :class="MIXIN_SETUP_UI.header">Anytime. No Line. <span v-html="MIXIN_TRADEMARK_SIGN"></span></div>

											<p
												class="pt-2 pb-5"
												:class="MIXIN_SETUP_UI.title"
											>
												Get your hassle-free medical consultation. Our Filipino specialist<br>doctors are just a phone call away to give you the care you<br>deserved.
											</p>

											<div>
												<!-- IOS -->
												<v-btn
													dark
													depressed
													rounded
													:x-large="!MIXIN_SETUP_UI.isSmallButton"
													:large="MIXIN_SETUP_UI.isSmallButton"
													color="#1665ce"
													class="my-3"
													min-width="60%"
													target="_blank"
													:href="MIXIN_MEDGATE_APP_IOS_LINK"
												>
													<v-icon left>mdi-apple</v-icon>
													Download iOS App
												</v-btn>

												<!-- Android -->
												<v-btn
													depressed
													rounded
													:x-large="!MIXIN_SETUP_UI.isSmallButton"
													:large="MIXIN_SETUP_UI.isSmallButton"
													color="white"
													class="blue--text text--darken-3 my-3"
													min-width="60%"
													:href="MIXIN_MEDGATE_APP_ANDROID_LINK"
													target="_blank"
												>
													<v-icon left>mdi-android</v-icon>
													Download Android App
												</v-btn>
											</div>
										</div>
									</v-row>
								</v-container>
							</v-col>
						</v-row>
					</v-card>
				</v-container>
			</div>

			<div id="faq" class="sec">
				<v-container>
					<v-row justify="center">
						<div
							class="head font-weight-bold"
							data-aos="fade-up"
							:class="MIXIN_SETUP_UI.header"
						>
							FAQs
						</div>
					</v-row>

					<v-row data-aos="fade-up" justify="center">
						<v-col cols="12" sm="12" md="8" lg="8" xl="8">
							<v-expansion-panels
								accordion
								flat
								active-class="active-faq"
							>
								<v-expansion-panel
									v-for="(faq, key) in faqs"
									:key="key"
								>
									<v-expansion-panel-header
										color="transparent"
									>
										<div class="primary--text text--darken-1" :class="MIXIN_SETUP_UI.title">{{ faq.question }}</div>
									</v-expansion-panel-header>

									<v-expansion-panel-content
										color="transparent"
									>
										<p class="text-justify" :class="MIXIN_SETUP_UI.subtitle">{{ faq.answer }}</p>
									</v-expansion-panel-content>

									<div v-if="faqs.length - 1 != key" class="primary" style="height: 2px"></div>

								</v-expansion-panel>
							</v-expansion-panels>
						</v-col>
					</v-row>
				</v-container>
			</div>
		</div>
  </div>
</template>

<script>
import FeatureRow from "@/components/medgate-app/FeatureRow.vue";

import Repository from "@/api/repositories";
const MedgateAppBannersApi = Repository.get("medgateAppBanners");
const MedgateAppFeaturesApi = Repository.get("medgateAppFeatures");
const MedgateAppFaqsApi = Repository.get("medgateAppFaqs");

export default {
  name: "MedgateApp",
  components: {
		FeatureRow
  },
  data() {
    return {
			banner: [],
			features: [],
			faqs: [],
			platforms: [
        {
          os: "IOS",
          icon: "apple",
          bg: "blue darken-3",
					text: "white",
					link: "/"
        },
        {
          os: "Android",
          icon: "android",
          bg: "white",
					text: "#0e6ccd",
					link: "/"
        }
			],
			services: [
				"Teleconsultation",
				"E-Prescription"
			]
		}
  },
	computed: {
		iframeHeight() {
			var size = '0';

			if (this.$vuetify.breakpoint.xs)
				size = '215';
			else if (this.$vuetify.breakpoint.sm)
				size = '480';
			else
				size = '605';

			return size;
		}
	},
  async mounted() {
		this.getMedgateAppFeatures();
		this.getMedgateAppFaqs();
		await this.getMedgateAppBanner();
		this.setHeaderColor();
  },
  methods: {
		setHeaderColor() {
      if (this.banner.backgroundColor)
        this.$store.commit('page/setHeaderColor', this.banner.backgroundColor)
      else
        this.$store.commit('page/defaultHeaderColor')
    },
    async getMedgateAppBanner() {
			try {
				const { data } = await MedgateAppBannersApi.get();

				if (data) {
					data.data.sort(function(a, b) {
						return a.precedence - b.precedence;
					});

					let apiData = data.data[0];

					let buttons = apiData.buttons.map(button => {
						return {
							name: button.label,
							icon: button.image,
							link: button.redirect,
							color: JSON.parse(button.styling).color
						}
					});

					let banner = {
						buttons: buttons,
						image: apiData.background_image.main,
						caption: apiData.caption,
						title: apiData.title,
						titleColor: apiData.styles.titleColor,
						captionColor: apiData.styles.captionColor,
						backgroundColor: apiData.styles.backgroundColor
					}

					this.banner = banner;
				}

				console.log('[medgate-app-banner]', data, this.banner);
			}
			catch(error) {
				console.log(error);
			}
		},
		async getMedgateAppFeatures() {
			try {
				const { data } = await MedgateAppFeaturesApi.get();

				if (data) {
					data.data.sort(function(a, b) {
						return a.precedence - b.precedence;
					});

					let features = data.data.map(feature => {
						return {
							title: feature.title,
							caption: feature.description,
							backgroundImage: feature.background_image.main
						}
					});

					this.features = features;
				}

				console.log('[medaate-app-features]', data, this.features);
			}
			catch(error) {
				console.log(error);
			}
		},
		async getMedgateAppFaqs() {
			try {
				const { data } = await MedgateAppFaqsApi.get();

				if (data) {
					data.data.sort(function(a, b) {
						return a.precedence - b.precedence;
					});

					let faqs = data.data.map(faq => {
						return {
							question: faq.question,
							answer: faq.answer
						}
					});

					this.faqs = faqs;
				}

				console.log('[medgate-app-faqs]', data, this.faqs);
			}
			catch(error) {
				console.log(error);
			}
		},
  }
};
</script>

<style lang="scss">
@import "@/assets/styles/variables.scss";

#video {
	.card-wrap {
		margin-left: 8%;
		margin-right: 8%;

		.text-wrap {
			// margin-left: 10%;;
		}
	}

	.video-image {
		border-top-right-radius: 8px;
		border-bottom-right-radius: 8px;
	}
}

#features {
	.header {
		height: 300px;
		background: white;
	}
}

#benefits {
	.card {
		height: 380px;
	}
	.image {
		height: 490px;
		background: url("~@/assets/images/others/doc_juan_2.png") 50% -44% / 60% no-repeat;
		// background-size: contain;
	}
	.app-row {
		color: white;

		.v-btn:hover {
			color: white !important;
		}
	}
}

#faq {
	background: white;

	.v-expansion-panel-header__icon {
		.v-icon {
			font-size: 50px !important;
		}
	}

	h3 {
		line-height: 1.6;
	}

	p {
		font-size: 14px;
	}

	.active-faq {
		h3 {
			color: black !important;
		}

		.v-expansion-panel-header__icon {
			.v-icon {
				color: $accent-blue !important;
			}
		}
	}
}
</style>
